import { Navigate, useParams } from "react-router-dom";

// Run Agent is now embedded as a tab inside the Agent Workspace.
// This redirect handles any bookmarked or shared /agents/:id/run URLs.
export function AgentRun() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/agents/${encodeURIComponent(id ?? "")}`} replace />;
}
